import { render, staticRenderFns } from "./ParamScrollComponent.vue?vue&type=template&id=369eb500&scoped=true"
import script from "./ParamScrollComponent.vue?vue&type=script&lang=js"
export * from "./ParamScrollComponent.vue?vue&type=script&lang=js"
import style0 from "./ParamScrollComponent.vue?vue&type=style&index=0&id=369eb500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369eb500",
  null
  
)

export default component.exports